import {Box, Center, Flex, Text} from '@chakra-ui/react';

interface LeftRightColumnTextProps {
  columnTitle?: string;
  leftColumn: string;
  rightColumn: string;
}

export const LeftRightColumnText: React.FC<LeftRightColumnTextProps> = ({
  columnTitle,
  leftColumn,
  rightColumn,
}) => {
  return (
    <Center>
      <Box pb={10} px={{base: 8, md: 12, lg: 16, '2xl': 24}}>
        <Box>
          <Text width="100%" textStyle={{base: 'h4_1c', md: 'h3_1c'}}>
            {columnTitle}
          </Text>
        </Box>
        <Flex flexDir={{base: 'column', md: 'column', lg: 'row'}}>
          <Box
            mr={{base: 0, lg: 4}}
            mt={{base: 5, md: 5}}
            w={{base: '327px', md: '584px', lg: '450px', '2xl': '510px'}}
            minH={{base: '300px', md: '175px', lg: '363px', '2xl': '297px'}}
          >
            <Text textStyle={{base: 'body3_1c', md: 'body2_1c'}}>
              {leftColumn}
            </Text>
          </Box>
          <Box
            ml={{base: 0, lg: 4}}
            mt={{base: 5, md: 5}}
            w={{base: '327px', md: '584px', lg: '450px', '2xl': '510px'}}
            minH={{base: '325px', md: '175px', lg: '363px', '2xl': '297px'}}
          >
            <Text textStyle={{base: 'body3_1c', md: 'body2_1c'}}>
              {rightColumn}
            </Text>
          </Box>
        </Flex>
      </Box>
    </Center>
  );
};
